export enum SidebarPosition {
    LEFT = 'left',
    RIGHT = 'right',
}

export type SidebarWidthProps = {
    defaultWidth?: number;
    minWidth?: number;
    maxWidth?: number;
};
